const cityCameroon = [
    "Abong-Mbang",
    "Akom II",
    "Akonolinga",
    "Akono",
    "Akoeman",
    "Ambam",
    "Awing",
    "Babadjou",
    "Bafang",
    "Bafia",
    "Bafoussam",
    "Bafut",
    "Baham",
    "Bali",
    "Balikumbat",
    "Bamenda",
    "Bamesso",
    "Bana",
    "Banda",
    "Bandjoun",
    "Bangangté",
    "Bankim",
    "Banyo",
    "Bare",
    "Bashéo",
    "Batchenga",
    "Batouri",
    "Bébédjia",
    "Bébora",
    "Bekondo",
    "Bélabo",
    "Bengbis",
    "Bertoua",
    "Bétaré-Oya",
    "Bibemi",
    "Bipindi",
    "Bogo",
    "Bokito",
    "Bonaléa",
    "Bot-Makak",
    "Boundjou",
    "Bourrha",
    "Buea",
    "Campo",
    "Dimako",
    "Dizangué",
    "Douala",
    "Doumé",
    "Dschang",
    "Ébolowa",
    "Edéa",
    "Efoulan",
    "Ekondo Titi",
    "Elig-Mfomo",
    "Endom",
    "Eséka",
    "Eseka",
    "Ewo",
    "Figuil",
    "Fontem",
    "Foumban",
    "Foumbot",
    "Fundong",
    "Galim",
    "Garoua",
    "Garoua-Boulaï",
    "Gashiga",
    "Gazawa",
    "Gobo",
    "Guider",
    "Guidiguis",
    "Hile-Hial",
    "Idabato",
    "Isanguele",
    "Kaélé",
    "Kai-Kai",
    "Kékem",
    "Kette",
    "Koza",
    "Kribi",
    "Kumba",
    "Kumbo",
    "Lagdo",
    "Limbé",
    "Logone-Birni",
    "Loum",
    "Maga",
    "Magba",
    "Makary",
    "Makénéné",
    "Malentouen",
    "Mamfé",
    "Mandjou",
    "Manjo",
    "Maroua",
    "Massangam",
    "Massock",
    "Mayo-Darlé",
    "Mbalmayo",
    "Mbandjock",
    "Mbanga",
    "Mbang",
    "Mbankomo",
    "Mbiame",
    "Mbouda",
    "Méiganga",
    "Melong",
    "Messaména",
    "Messondo",
    "Meyomessala",
    "Meyomessi",
    "Mindif",
    "Minta",
    "Mitsoudjé",
    "Mokolo",
    "Moloundou",
    "Monatélé",
    "Mora",
    "Moulvoudaye",
    "Moutourwa",
    "Mudemba",
    "Muyuka",
    "Nanga-Eboko",
    "Ndelele",
    "Ndikiniméki",
    "Ndop",
    "Ngaoundal",
    "Ngaoundéré",
    "Ngomedzap",
    "Ngoro",
    "Ngoulemakong",
    "Ngoura",
    "Nguelebok",
    "Nkolafamba",
    "Nkongsamba",
    "Nkondjock",
    "Nkoteng",
    "Ntui",
    "Nyambaka",
    "Obala",
    "Okola",
    "Olamze",
    "Olinga",
    "Penja",
    "Petté",
    "Pitoa",
    "Poli",
    "Rey Bouba",
    "Sa'a",
    "Sangmélima",
    "Santchou",
    "Somalomo",
    "Soulédé-Roua",
    "Tchati-Bali",
    "Tcholliré",
    "Tibati",
    "Tignère",
    "Tiko",
    "Tingong",
    "Tinto",
    "Toko",
    "Tombel",
    "Tonga",
    "Touboro",
    "Touloum",
    "Touroua",
    "Vélé",
    "Wina",
    "Wum",
    "Yabassi",
    "Yagoua",
    "Yaoundé",
    "Yokadouma",
    "Zina"
]

export default cityCameroon;